import axios from "@/api/index";
let method = 'GET';
/*切换节点*/
export function getRegionNew(pid) {
    return axios.get("https://bqwapi.bangqichat.com/versions/dynamic/getRegionNew?pid=" + pid)
}
/*数字应用各个分类商品列表*/
export const getCategoryGoodsList=data=>axios.post('/kdb/category/getCategoryGoodsList',data)
/*外包行业列表*/
export const outsourcingIndustryList=data=>axios.get('/versions/outsourcing/outsourcingIndustryList',data)
/*招标推荐列表*/
export const tradingFloorsList=data=>axios.post('/versions/outsourcing/tradingFloorsList',data)
/*服务顾问*/
export const serviceAdvisor=data=>axios.get('/home/restPlatformHome/serviceAdvisor',data)
/*服务商数量/惠企政策数量/服务产品数量*/
export const servicesNumber=data=>axios.post('/home/restPlatformHome/servicesNumber',data)
/*服务云首页 -- 服务节点*/
export const serviceNode=data=>axios.post('/home/restPlatformHome/serviceNode',data)
/*服务平台首页 -- 关于平台*/
export const aboutPlatform=data=>axios.post('/home/restPlatformHome/aboutPlatform',data)
/*服务平台首页(公共法律服务/企业申报/银企服务)*/
export const vsPlatformHome=data=>axios.post('/home/restPlatformHome/vsPlatformHome',data)
/*新版APP精选一级分类下商品*/
export const newGetFirstAllGoods=data=>axios.post('/home/rest/RevisionOneHome/newGetFirstAllGoods',data)
/*本店商品搜索*/
export const searchOurShopGoods=data=>axios.post('/versions/rest/servicePlatform/searchOurShopGoods',data)
/*新版APP首页搜索--价格*/
export const newHomeSearchPrice=data=>axios.post('/home/rest/RevisionOneHome/newHomeSearchPrice',data)
/*新版APP首页es商品搜索--综合/销量*/
export const newHomeSearch=data=>axios.post('/home/rest/RevisionOneHome/newHomeSearch',data)
/*新版APP首页搜索--综合/销量*/
export const newHomeSearchOld=data=>axios.post('/home/rest/RevisionOneHome/newHomeSearchOld',data)
/*新版APP首页es店铺搜索--店铺*/
export const newHomeSearchShop=data=>axios.post('/home/rest/RevisionOneHome/newHomeSearchShop',data)
/*新版APP首页搜索--店铺*/
export const newHomeSearchShopOld=data=>axios.post('/home/rest/RevisionOneHome/newHomeSearchShopOld',data)
/*商品详情*/
export const newEvaluate=data=>axios.post('/home/rest/RevisionOneGoods/newEvaluate',data)
/*店铺分类*/
export const newShopClass=data=>axios.post('/home/rest/RevisionOneGoods/newShopClass',data)
/*店铺热销*/
export const hotShop=data=>axios.post('/versions/rest/servicePlatform/hotShop',data)
/*商品详情下的推荐顾问*/
export const goodRecommendedConsultant=data=>axios.post('/home/rest/RevisionOneGoods/goodRecommendedConsultant',data)
/*进店*/
export const joinShop=data=>axios.post('/home/rest/RevisionOneGoods/joinShop',data)
/*是否关注店铺*/
export const whetherToFollowTheShop=data=>axios.post('/home/rest/RevisionOneGoods/whetherToFollowTheShop',data)
/*商品详情--是否有优惠券可领取*/
export const goodsForCoupons=data=>axios.post('/home/rest/RevisionOneGoods/goodsForCoupons',data)
/*商品详情--可领优惠券列表*/
export const couponsAvailableList=data=>axios.post('/home/rest/RevisionOneGoods/couponsAvailableList',data)
/*商品优惠券领取*/
export const getCoupons=data=>axios.post('/home/rest/RevisionOneHome/getCoupons',data)
/*商品收藏/关注店铺*/
export const saveCollect=data=>axios.post('/home/rest/RevisionOneGoods/saveCollect',data)
/*取消商品收藏/取消店铺关注*/
export const removeCollect=data=>axios.post('/home/rest/RevisionOneGoods/removeCollect',data)
/*店铺服务/服务搜索*/
export const storeServiceAndSearch=data=>axios.post('/home/rest/RevisionOneGoods/storeServiceAndSearch',data)
/*新版PC店铺内es商品搜索--综合*/
export const pcShopGoodsForSearchComprehensive=data=>axios.post('/home/rest/RevisionOneHome/pcShopGoodsForSearchComprehensive',data)
/*新版PC店铺内es商品搜索--价格*/
export const pcShopGoodsForSearchPrice=data=>axios.post('/home/rest/RevisionOneHome/pcShopGoodsForSearchPrice',data)
/*新版PC店铺内es商品搜索--销量*/
export const pcShopGoodsForSearchSalesVolume=data=>axios.post('/home/rest/RevisionOneHome/pcShopGoodsForSearchSalesVolume',data)
/*服务平台 -- 热门搜索关键词*/
export const hotSearchKeywords=data=>axios.get('/versions/rest/servicePlatform/hotSearchKeywords',data)
/*提交订单*/
export const submitOrder=data=>axios.post('/order/order/submitOrder',data)
/*微信扫码充值接口:is_pcOrder为true则为：pc用户扫码支付。 为false：开店宝商家充值*/
export const wxPay=data=>axios.post('/pay/NativeWxPay/jnonly/wxPay',data)
/*查询订单*/
export const refund=data=>axios.post('/pay/wxPay/refund',data)
/*招标状态/截止时间 列表*/
export const tenderStatusList=data=>axios.post('/versions/outsourcing/tenderStatusList',data)
/*交易公告列表*/
export const transactionAnnouncementList=data=>axios.post('/versions/outsourcing/transactionAnnouncementList',data)
/*价格区间*/
export const priceRangeList=data=>axios.get('/versions/outsourcing/priceRangeList',data)
/*保存招标需求*/
export const saveBiddingRequirements=data=>axios.post('/pay/myPurse/saveBiddingRequirements',data)
/*发布招标需求提交订单*/
export const publishBiddingSubmitOrders=data=>axios.post('/pay/myPurse/publishBiddingSubmitOrders',data)
/*我的招标列表*/
export const myTenderList=data=>axios.post('/versions/outsourcing/myTenderList',data)
/*投标列表*/
export const biddingList=data=>axios.post('/versions/outsourcing/biddingList',data)
/*收藏列表*/
export const favoritesList=data=>axios.post('/versions/outsourcing/favoritesList',data)
/*收藏删除*/
export const delFavorites=data=>axios.post('/versions/outsourcing/delFavorites',data)
/*招标详情*/
export const tendersDetails=data=>axios.post('/versions/outsourcing/tendersDetails',data)
/*投标服务商列表*/
export const biddingServiceProviderList=data=>axios.post('/versions/outsourcing/biddingServiceProviderList',data)
/*招标收藏/取消收藏*/
export const biddingCollect=data=>axios.post('/versions/outsourcing/biddingCollect',data)
/*选中服务商列表*/
export const selectedServiceProviderList=data=>axios.post('/versions/outsourcing/selectedServiceProviderList',data)
/*提交投标报价*/
export const biddingQuote=data=>axios.post('/versions/outsourcing/biddingQuote',data)
/*交易大厅数据统计*/
export const tradingFloorStatistics=data=>axios.post('/versions/outsourcing/tradingFloorStatistics',data)
/*投标书详情*/
export const biddingTendersDetails=data=>axios.post('/versions/outsourcing/biddingTendersDetails',data)